import { Controller } from "@hotwired/stimulus"

// "Configuración automática" on the trial wizard's steps 2-4: while the
// checkbox is on, every control inside the body is disabled (so the server
// keeps the suggestion as the source of truth) and the body is dimmed.
// Unchecking hands the prefilled suggestion over for editing.
export default class extends Controller {
  static targets = ["toggle", "body"]

  connect() { this.refresh() }

  refresh() {
    const auto = this.hasToggleTarget && this.toggleTarget.checked
    this.bodyTarget.classList.toggle("opacity-60", auto)
    this.bodyTarget.classList.toggle("pointer-events-none", auto)
    this.bodyTarget.querySelectorAll("input, select, textarea, button").forEach((el) => {
      el.disabled = auto
    })
  }
}
